import React from 'react';

export function BusLogoIcon({ size = 72 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Pura Ruta logo"
    >
      {/* Fondo negro con esquinas redondeadas estilo app icon */}
      <rect width="72" height="72" rx="16" fill="#1a1a1a"/>

      {/* P blanca */}
      <text
        x="11"
        y="51"
        fontFamily="'Playfair Display', Georgia, serif"
        fontWeight="700"
        fontSize="42"
        fill="#FFFFFF"
        letterSpacing="-1"
      >P</text>

      {/* R verde */}
      <text
        x="38"
        y="51"
        fontFamily="'Playfair Display', Georgia, serif"
        fontWeight="700"
        fontSize="42"
        fill="#1D9E75"
        letterSpacing="-1"
      >R</text>
    </svg>
  );
}
